import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { ChatLocationContextImport } from "../../../../provider/chats/chats/chat_location/ChatLocationContextProvider";

const ChatLocationActions = () => {
  const { showSearch, updateShowSearch } = ChatLocationContextImport();
  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default ChatLocationActions;
